import { render, staticRenderFns } from "./recomStatus.vue?vue&type=template&id=1e78602b&scoped=true"
import script from "./recomStatus.vue?vue&type=script&lang=js"
export * from "./recomStatus.vue?vue&type=script&lang=js"
import style0 from "./recomStatus.vue?vue&type=style&index=0&id=1e78602b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e78602b",
  null
  
)

export default component.exports